import { firebase, disconnectDb } from 'app-modules/application/utils/firebase';
import { LOAD } from './types';
import { triviaLoadAnswerActionThunk as loadAnswer } from './loadAnswer';

export const triviaLoadActionThunk = (
  triviaId,
  { answerTimeout, notClearReveal = false } = {},
) => async (dispatch, getState) => {
  try {
    const {
      trivia: { isConfigured },
    } = getState();
    if (!isConfigured) {
      throw new Error('Trivia not configured');
    }
    await dispatch({ type: LOAD.REQUEST, payload: { notClearReveal } });

    const db = firebase.database();
    db.goOnline();
    const triviaSnapshot = await db.ref(`/trivias/${triviaId}`).once('value');

    if (triviaSnapshot.exists()) {
      const triviaData = triviaSnapshot.val();

      await dispatch(loadAnswer(triviaId));
      await dispatch({
        type: LOAD.SUCCESS,
        payload: {
          id: triviaId,
          answerTimeout,
          ...triviaData,
        },
      });
    } else {
      throw new Error('Trivia not found');
    }
  } catch (err) {
    await dispatch({ type: LOAD.FAILURE, payload: err, error: true });
  } finally {
    disconnectDb();
  }
};
